import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "SIZE_FORM";
export const SizeFormAction = createFormAction(FORM_KEY);
